import antdKkKZ from 'antd/es/locale/kk_KZ';
import antdRuRU from 'antd/es/locale/ru_RU';
import antdEnUS from 'antd/es/locale/en_US';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import kk from './locales/kk_KZ.json';
import ru from './locales/ru_RU.json';
import en from './locales/en_US.json';

export const resources = {
    ru: {
        translation: ru,
        antd: antdRuRU,
    },
    kk: {
        translation: kk,
        antd: antdKkKZ,
    },
    en: {
        translation: en,
        antd: antdEnUS,
    },
};

let lan = localStorage.getItem('lan') === "ENG" ? 'ru' : (localStorage.getItem('lan') === "РУС" ? 'ru' : (localStorage.getItem('lan') === "ҚАЗ" ? 'ru' : 'ru'))

i18n.use(initReactI18next).init({
    resources,
    fallbackLng: lan,
    lng: lan,
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
